import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/pages/home/home'
import About from '@/pages/about/about'
import GetStarted from '@/pages/get-started/get-started'
import Services from '@/pages/services/services'
import Contact from '@/pages/contact/contact'
import Covid19 from '@/pages/covid-19/covid-19'
import Accessibility from '@/pages/accessibility/accessibility'
import Styleguide from '@/pages/styleguide/styleguide'
import scrollBehavior from '@/shared/functionality/scroll-behavior'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      navigation: true,
      component: Home
    },
    {
      path: '/about',
      name: 'About',
      navigation: true,
      component: About
    },
    {
      path: '/get-started',
      name: 'Get Started',
      navigation: true,
      component: GetStarted
    },
    {
      path: '/services',
      name: 'Services',
      navigation: true,
      component: Services
    },
    {
      path: '/contact',
      name: 'Contact',
      navigation: true,
      component: Contact
    },
    {
      path: '/covid-19',
      name: 'Covid 19',
      navigation: true,
      component: Covid19
    },
    {
      path: '/accessibility',
      name: 'Accessibility',
      navigation: false,
      component: Accessibility
    },
    {
      path: '#',
      name: 'Patient Forms',
      navigation: true,
      children: [
        {
          name: 'Health History Form',
          path: '/form-h',
          beforeEnter () {
            window.open('https://formsroostergrin.com/Restorationdentalgroup/Health-History-Form.html', '_blank')
          }
        },
        {
          name: 'New Patient Paperwork',
          path: '/form-p',
          beforeEnter () {
            window.open('https://formsroostergrin.com/Restorationdentalgroup/Restorationdentalgroup-Patient-information-Form.html', '_blank')
          }
        }
      ]
    },
    {
      path: '/styleguide',
      name: 'Styleguide',
      navigation: false,
      component: Styleguide
    },
    {
      path: '/*',
      name: '404',
      navigation: false,
      component: Home
    }
  ],
  scrollBehavior
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js